if (!customElements.get('expandable-text')) {
    customElements.define(
      'expandable-text',
      class ExpandableText extends HTMLElement {
        constructor() {
          super();
          this.textToExpand = this.querySelector('.product__description');
          this.expandButton = this.querySelector('.description-read-more-button');
        }

        connectedCallback() {
            if (!this.textToExpand && !this.expandButton) return;

            // temporarily unclamp to get true height values
            const heights = this.calculateHeights();
            let clampedHeight = heights.clampedHeight;
            let fullHeight = heights.fullHeight;

            // compare heights before showing button
            if (fullHeight > clampedHeight) {
                this.expandButton.hidden = false;
            }

            this.expandButton.addEventListener('click', (e) => {
                this.textToExpand.classList.toggle('is-open');

                const mobileInfo = this.textToExpand.closest('.product-mobile-info') ?? "";

                if (mobileInfo) {
                    mobileInfo.classList.toggle('is-active');
                }
                
                if (this.textToExpand.classList.contains('is-open')) {
                    this.textToExpand.style.maxHeight = fullHeight + "px";
                    this.expandButton.textContent = "Read less";
                } else {
                    this.textToExpand.style.webkitLineClamp = 'unset';
                    this.textToExpand.style.maxHeight = clampedHeight + "px";
                    this.expandButton.textContent = "Read more";
                }
            });

            window.addEventListener("resize", () => {
                if (this.textToExpand.classList.contains('is-open')) return;

                // redefined heights
                const heights = this.calculateHeights();

                clampedHeight = heights.clampedHeight == 0 ? 50 : heights.clampedHeight;
                this.textToExpand.style.maxHeight = clampedHeight + "px";

                fullHeight = heights.fullHeight;

                if (fullHeight > clampedHeight) {
                    this.expandButton.hidden = false;
                }
            });
        }

        calculateHeights() {
            const clampedHeight = this.textToExpand.getBoundingClientRect().height;

            this.textToExpand.style.webkitLineClamp = 'unset';
            this.textToExpand.style.maxHeight = 'none';

            const fullHeight = this.textToExpand.scrollHeight;

            this.textToExpand.style.webkitLineClamp = 2;
            this.textToExpand.style.maxHeight = clampedHeight + "px";

            return { clampedHeight, fullHeight };
        }
      }
    );
  }
  